import React, { useState } from "react";
import { api, formatApiErrorDetail } from "../lib/api";

// Mettre à jour ces liens avec les vrais comptes
const SOCIALS = [
  { label: "Instagram", handle: "@lestanddor", href: "https://instagram.com/lestanddor" },
  { label: "TikTok", handle: "@lestanddor", href: "https://tiktok.com/@lestanddor" },
  { label: "YouTube", handle: "Le Stand d'Or", href: "https://youtube.com/@lestanddor" },
  { label: "Twitch", handle: "lestanddor", href: "https://twitch.tv/lestanddor" },
];

export default function FollowBlock({ title, subtitle }) {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState({ kind: "idle", message: "" });

  const submit = async (e) => {
    e.preventDefault();
    setStatus({ kind: "loading", message: "" });
    try {
      const { data } = await api.post("/newsletter/subscribe", { email });
      if (data.status === "already_subscribed") {
        setStatus({ kind: "ok", message: "Vous êtes déjà inscrit·e." });
      } else {
        setStatus({ kind: "ok", message: "Merci — vous serez informé·e en avant-première." });
        setEmail("");
      }
    } catch (err) {
      setStatus({ kind: "error", message: formatApiErrorDetail(err.response?.data?.detail) || "Une erreur est survenue." });
    }
  };

  return (
    <section
      style={{ borderTop: "1px solid #1c1c1c", background: "#050505" }}
      data-testid="follow-block"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-24 md:py-32">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-16">

          {/* Texte */}
          <div className="md:col-span-5">
            <p className="label mb-6" style={{ color: "#C9A961" }}>Restez informé·e</p>
            <h2
              className="font-serif"
              style={{ fontSize: "clamp(32px, 4vw, 56px)", lineHeight: 1.05, color: "#F8F6F0", letterSpacing: "-0.02em" }}
            >
              {title || "Les nominations arrivent."}
            </h2>
            {subtitle && (
              <p className="mt-6" style={{ color: "rgba(248,246,240,0.6)", fontSize: 16, lineHeight: 1.75 }}>
                {subtitle}
              </p>
            )}

            {/* Réseaux */}
            <div className="mt-12">
              <p className="label mb-5" style={{ color: "#A1A1AA" }}>Suivre le Stand d'Or</p>
              <div className="flex flex-col gap-4">
                {SOCIALS.map((s) => (
                  <a
                    key={s.label}
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group flex items-center justify-between"
                    style={{
                      borderBottom: "1px solid #1c1c1c",
                      paddingBottom: 14,
                      textDecoration: "none",
                    }}
                  >
                    <span
                      className="font-serif"
                      style={{ fontSize: 20, color: "#F8F6F0", transition: "color 300ms" }}
                      onMouseEnter={(e) => (e.currentTarget.style.color = "#C9A961")}
                      onMouseLeave={(e) => (e.currentTarget.style.color = "#F8F6F0")}
                    >
                      {s.label}
                    </span>
                    <span className="label" style={{ color: "#A1A1AA" }}>{s.handle} →</span>
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Newsletter */}
          <div className="md:col-span-5 md:col-start-8 flex flex-col justify-center">
            <p className="label mb-4" style={{ color: "#A1A1AA" }}>La lettre officielle</p>
            <p
              className="font-serif mb-8"
              style={{ fontSize: "clamp(20px, 2.2vw, 28px)", lineHeight: 1.3, color: "#F8F6F0" }}
            >
              Recevez les annonces en avant-première — nominations, jury, date de cérémonie.
            </p>

            {status.kind === "ok" ? (
              <p
                className="label"
                style={{ color: "#C9A961", border: "1px solid rgba(201,169,97,0.3)", padding: "16px 20px" }}
              >
                {status.message}
              </p>
            ) : (
              <form onSubmit={submit} data-testid="follow-block-newsletter-form">
                <label htmlFor="fb-email" className="label block mb-3" style={{ color: "#A1A1AA" }}>
                  Votre adresse e-mail
                </label>
                <input
                  id="fb-email"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="prenom.nom@exemple.fr"
                  className="input-editorial"
                  style={{ width: "100%", marginBottom: 12 }}
                  disabled={status.kind === "loading"}
                />
                {status.kind === "error" && (
                  <p className="label mb-4" style={{ color: "#e05c5c" }}>{status.message}</p>
                )}
                <button
                  type="submit"
                  className="btn-solid"
                  style={{ width: "100%" }}
                  disabled={status.kind === "loading"}
                >
                  {status.kind === "loading" ? "Inscription…" : "S'inscrire à la lettre →"}
                </button>
              </form>
            )}

            <p className="label mt-6" style={{ color: "rgba(248,246,240,0.3)" }}>
              Aucun spam. Désabonnement en un clic.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
}
